import { Id } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useDeleteEvent() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: deleteEvent,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(null)
    },
  })

  async function deleteEvent(id: Id) {
    return server.delete(`/v2/event/custom/${id}`)
  }
}
